import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const FormArray = () => (
  <ComponentDocs
    name="<Form.Array/>"
    entry="ArrayField"
    propsEntry="ArrayFieldProps"
    namespace="FormCollections"
  >
    <ComponentExample
      name="Array field"
      import={import("examples/Forms/FormArray/ArrayFieldExample")}
      rawImport={import("examples/Forms/FormArray/ArrayFieldExample?raw")}
    />
    <ComponentExample
      name="Auto add / remove"
      import={import("examples/Forms/FormArray/AutoAddRemoveExample")}
      rawImport={import("examples/Forms/FormArray/AutoAddRemoveExample?raw")}
    />
    <ComponentExample
      name="Propagate updates"
      description="By default Form.Array will only re-render if one of the items change. To re-render when external variables change pass them as a dependency array to the propagateUpdates prop."
      import={import("examples/Forms/FormArray/PropagateArrayUpdatesExample")}
      rawImport={import(
        "examples/Forms/FormArray/PropagateArrayUpdatesExample?raw"
      )}
    />
    <ComponentExample
      name="Accessing items"
      import={import("examples/Forms/FormArray/AccessingItemsExample")}
      rawImport={import("examples/Forms/FormArray/AccessingItemsExample?raw")}
    />
  </ComponentDocs>
);

export default FormArray;
